import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';
import { DEFAULT_PAGE, DEFAULT_PAGE_SIZE } from '../../../shared/ui/pagination/pagination.config';
import { FunctionRun, FunctionRunLog, FunctionRunQuery } from '../models/function-run.model';
import { PagedResult } from '../models/pagination.model';
import { UserImportRecord } from '../models/user-import.model';

@Injectable({
  providedIn: 'root',
})
export class FunctionRunsApiService {
  private readonly http = inject(HttpClient);
  private readonly api = environment.apiUrl.replace(/\/$/, '');

  getQueue(): Observable<FunctionRun[]> {
    return this.http.get<FunctionRun[]>(`${this.api}/function-queue`);
  }

  cancelRun(runId: number): Observable<FunctionRun> {
    return this.http.post<FunctionRun>(`${this.api}/function-queue/${runId}/cancel`, {});
  }

  getRuns(
    page = DEFAULT_PAGE,
    pageSize = DEFAULT_PAGE_SIZE,
    query: FunctionRunQuery = {},
  ): Observable<PagedResult<FunctionRun>> {
    let params = new HttpParams().set('page', page).set('pageSize', pageSize);
    params = this.addParams(params, query);
    return this.http.get<PagedResult<FunctionRun>>(`${this.api}/function-runs`, { params });
  }

  getRun(runId: number): Observable<FunctionRun> {
    return this.http.get<FunctionRun>(`${this.api}/function-runs/${runId}`);
  }

  getRunLogs(runId: number): Observable<FunctionRunLog[]> {
    return this.http.get<FunctionRunLog[]>(`${this.api}/function-runs/${runId}/logs`);
  }

  getRunUsers(
    runId: number,
    page = DEFAULT_PAGE,
    pageSize = DEFAULT_PAGE_SIZE,
  ): Observable<PagedResult<UserImportRecord>> {
    const params = new HttpParams().set('page', page).set('pageSize', pageSize);
    return this.http.get<PagedResult<UserImportRecord>>(`${this.api}/function-runs/${runId}/users`, { params });
  }

  private addParams(params: HttpParams, values: object): HttpParams {
    let result = params;
    Object.entries(values).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        result = result.set(key, String(value));
      }
    });
    return result;
  }
}
